module.exports = __webpack_public_path__ + "resource/img/moon-toggle.23bf69e0.svg";